<template>
  <v-dialog v-model="show" :max-width="width" persistent>
    <v-card>
      <slot name="title">
        <v-card-title class="headline" v-if="title">
          {{ title }}
        </v-card-title>
      </slot>
      <v-card-text>
        <slot v-bind:item="tmp"></slot>
      </v-card-text>
      <slot name="actions">
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="cancel">
            Cancel
          </v-btn>
          <v-btn color="accent" text @click="confirm">
            Continue
          </v-btn>
        </v-card-actions>
      </slot>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Wraps a persistent dialog component to handle confirmation for sensitive actions
 *
 * The default slot defines the body of the dialog component
 *
 * The tmp variable is used to hang onto and pass arbitrary data around either for display
 * or callback purposes.
 */
export default {
  name: 'ConfirmDialog',
  props: {
    width: [String, Number],
    title: String,
  },
  data() {
    return {
      show: false,
      tmp: null,
    };
  },
  methods: {
    cancel() {
      this.$emit('cancel', this.tmp);
      this.close();
    },
    confirm() {
      this.$emit('continue', this.tmp);
      this.close();
    },
    open(data) {
      this.show = true;
      this.tmp = data;
    },
    close() {
      this.show = false;
      this.tmp = null;
    },
  },
};
</script>
